document.addEventListener("DOMContentLoaded", function () {
  const burger = document.querySelector(".header__burger");
  const mobileMenu = document.querySelector("#mobile-menu-popup");
  const mobileExitMenu = document.querySelector(".mobile-menu-popup__cross");

  burger.addEventListener("click", function () {
    mobileMenu.classList.add("opened");
  });

  mobileExitMenu.addEventListener("click", function () {
    mobileMenu.classList.remove("opened");
  });
});
